import {useSelector} from 'react-redux';
import isEqual from 'lodash.isequal';
import {RootState} from '../../store';

export function useAppSelector<T extends (state: RootState) => ReturnType<T>>(
  selector: T,
) {
  return useSelector.withTypes<RootState>()(selector, isEqual);
}
